import React from 'react';

function Bolt({ className }) {
  return (
    <div className={`bolt ${className}`}>
      <span className="bolt__line-1"></span>
      <span className="bolt__line-2"></span>
    </div>
  );
}

export function Bolts() {
  return (
    <>
      <Bolt className="bolt-up-left" />
      <Bolt className="bolt-up-right" />
      <Bolt className="bolt-down-left" />
      <Bolt className="bolt-down-right" />
    </>
  );
}
